import React, { Component } from 'react';
import {Link} from 'react-router-dom';
import '../App.css';

//TODO: add alts to imgs

export default class CatLinks extends Component {
  constructor(props){
    super(props);
    this.state = {
      // id used for db lookup 
      'cat_names': [
        'relationships',
        'mentalhealth',
        'sexualorientation',
        'loss',
        'race',
        'suicide',
        'abuse',
        'addiction',
        'eatingdisorders',
        'miscellaneous',
      ]
    };
  }
  render() {
    let links = [];
    this.state.cat_names.forEach((cat_id) => {
      links.push(<Link to={"/category/"+cat_id}>
        <img className="cat_img" src={"/images/"+cat_id+".png"}/>
      </Link>);
    });
    
    return (
      <div className="cat_div">
        {links}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/CatLinks.js